<script>
export default {
  name: "EgToggleButton",
  props: {
    label: {
      type: String,
      default: "",
    },
    pressed: Boolean,
    horizontal: Boolean,
  },
  emits: ["click"],
};
</script>

<template>
  <eg-b-button
    :pressed="pressed"
    class="new-rubric-button"
    :style="{
      flexDirection: horizontal ? 'row' : 'column',
    }"
    @click="$emit('click')"
  >
    <slot></slot>
    {{ label }}
  </eg-b-button>
</template>

<style scoped lang="scss">
.new-rubric-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  max-height: 36px;
  background: white;
  border: 1px #dfdfdf solid;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 170%;
  letter-spacing: 0px;
  padding: 8px 24px;
  color: var(--grey-800);

  &[aria-pressed="true"] {
    background: #f6f2ff !important;
    border: 1px #e5ebf0 solid !important;
    color: var(--black-900);
  }

  &:hover {
    background: #f6f2ff !important;
    border: 1px #e5ebf0 solid !important;
    color: var(--black-900);
  }

  &.active {
    border-color: var(--color-stroke-primary-default, #8a3ffc) !important;
    background: var(--color-surface-neutral-hover, #f6f2ff) !important;
  }

  &:focus {
    box-shadow: none !important;
  }
}
</style>
